import { useAtomValue, useSetAtom } from 'jotai';
import { ReactNode, useEffect } from 'react';
import { PreloadedQuery, usePreloadedQuery, useQueryLoader } from 'react-relay';

import { businessInitQuery } from '@/__generated__/businessInitQuery.graphql';
import { businessStatusQuery } from '@/graphql/query/survey/business';
import { displayBusinessNameAtom, isCompletedCurrentBusinessSurveyAtom } from '@/lib/stores/survey/business';
import { currentBusinessBmanTinAtom, refundHistoryIdAtom } from '@/lib/stores/survey/common';

const BusinessSetAtomProvider = ({ queryRef, children }: { queryRef: PreloadedQuery<businessInitQuery>; children: ReactNode }) => {
  const { getSurveyBusinessAnswer } = usePreloadedQuery<businessInitQuery>(businessStatusQuery, queryRef);
  const setDisplayBusinessName = useSetAtom(displayBusinessNameAtom);
  const setIsCompleted = useSetAtom(isCompletedCurrentBusinessSurveyAtom);

  useEffect(() => {
    if (getSurveyBusinessAnswer.result && getSurveyBusinessAnswer.businessAnswer?.[0]) {
      const business = getSurveyBusinessAnswer.businessAnswer[0];
      setDisplayBusinessName(business?.tnm || business?.bsno || '고객');
      setIsCompleted(business?.isCompleted || false);
    }
  }, [getSurveyBusinessAnswer.result, getSurveyBusinessAnswer.businessAnswer, setDisplayBusinessName, setIsCompleted]);

  return <>{children}</>;
};

export const BusinessProvider = ({ children }: { children: ReactNode }) => {
  const [queryRef, loadQuery] = useQueryLoader<businessInitQuery>(businessStatusQuery);
  const refundHistoryId = useAtomValue(refundHistoryIdAtom);
  const currentBusinessBmanTin = useAtomValue(currentBusinessBmanTinAtom);

  useEffect(() => {
    if (refundHistoryId && currentBusinessBmanTin) {
      loadQuery({
        refundHistoryId,
        bmanTin: currentBusinessBmanTin
      });
    }
  }, [loadQuery, refundHistoryId, currentBusinessBmanTin]);

  if (!queryRef) return <></>;
  return <BusinessSetAtomProvider queryRef={queryRef}>{children}</BusinessSetAtomProvider>;
};
